import { CoreStakeholdersName } from './name';
import { coreStakeholdersRemoveSyncSlice } from './remove';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteStakeholder } from '@api';

export const coreStakeholdersDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [ coreStakeholdersRemoveSyncSlice.syncActionCreator ]
	},
	name: CoreStakeholdersName,
	receive: false,
	request: true,
	requestHandler: deleteStakeholder
});
